module.exports = __webpack_public_path__ + "icon-web@2x.png?b1c5ec370d0f507144d5d74ea968e4ee";